import * as React from "react";
import { forwardRef } from "react";
const SvgCheckDash = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 2, viewBox: "0 0 10 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 1, y1: 1, x2: 9, y2: 1, stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgCheckDash);
export { ForwardRef as ReactComponent };
